<div class="{{ navbarClass }}" [class.is-sticky]="isSticky">
    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
            <a
                class="navbar-brand"
                routerLink="/"
                queryParamsHandling="merge"
            >
                <img
                    src="assets/img/mr-logo.png"
                    width="40"
                    height="40"
                    alt="logo"
                    class="d-inline-block align-text-top"
                />
                mandarvl
            </a>

            <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mx-auto">
                    <li class="nav-item">
                        <a routerLink="/" queryParamsHandling="merge" class="nav-link">{{
                            "nav.home" | translate
                        }}</a>
                    </li>
                    <li class="nav-item">
                        <a href="#skills" class="nav-link">{{
                            "nav.skills" | translate
                        }}</a>
                    </li>
                    <li class="nav-item">
                        <a href="#tech" class="nav-link">{{
                            "nav.technologies" | translate
                        }}</a>
                    </li>
                    <li class="nav-item">
                        <a
                            href="#projects"
                            (click)="analyticsService.onProjectScroll('navbar')"
                            class="nav-link"
                            >{{ "nav.projects" | translate }}</a
                        >
                    </li>
                    <li class="nav-item">
                        <a
                            href="#contact"
                            (click)="analyticsService.onContactScroll('navbar')"
                            class="nav-link"
                            >{{ "nav.contact" | translate }}</a
                        >
                    </li>
                </ul>
                <div class="others-options d-flex flex-wrap align-items-center gap-2">
                    <div
                        class="lang-switch btn-group btn-group-sm"
                        role="group"
                        [attr.aria-label]="'nav.languageAria' | translate"
                    >
                        <button
                            type="button"
                            class="btn btn-outline-secondary"
                            [class.active]="!isFrench"
                            (click)="setLang('en')"
                        >
                            {{ "nav.langEn" | translate }}
                        </button>
                        <button
                            type="button"
                            class="btn btn-outline-secondary"
                            [class.active]="isFrench"
                            (click)="setLang('fr')"
                        >
                            {{ "nav.langFr" | translate }}
                        </button>
                    </div>
                    <a
                        href="#contact"
                        (click)="analyticsService.onContactScroll('navbar_cta')"
                        class="default-btn"
                        >{{ "nav.hireMe" | translate }}<span></span
                    ></a>
                </div>
            </div>
        </nav>
    </div>
</div>
